import Vue from 'vue'
import Router from 'vue-router'
import FirstPage from '@/page/firstPage/firstPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'FirstPage',
      component: FirstPage
    },
    // 可以添加其他路由
    // {
    //   path: '/contact',
    //   name: 'Contact',
    //   component: () => import('@/page/contactPage/contactPage.vue')
    // }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js